import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { StreamTile } from '../../../models'
import { SportDataSummary } from '../../../../shared/sport-data/types'
import { StreamTileThumbnail } from 'src/app/live/models/stream-tile-thumbnail.model'
import { ReplaySubject } from 'rxjs'

@Component({
  selector: 'flo-stream-tile-sport-data',
  templateUrl: './stream-tile-sport-data.component.html',
  styleUrls: ['./stream-tile-sport-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StreamTileSportDataComponent {
  public readonly streamTileThumbnailProps$ = new ReplaySubject<StreamTileThumbnail>(1)
  public readonly view$ = new ReplaySubject<StreamTile>(1)
  @Input()
  public set view(value: StreamTile) {
    this.streamTileThumbnailProps$.next({
      image: value.streamThumbnail,
      canRemove: value.canRemove,
      canAdd: value.canAdd,
      isPlaying: value.isPlaying || false,
      name: value.title
    })
    this.view$.next(value)
  }
  @Input()
  sportData?: SportDataSummary
}
